"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EmployeeClaimsImpl_ec, _EmployeeBuilder_claims;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeBuilder = exports.EmployeeClaimNames = void 0;
exports.FromEmployeeWireClaims = FromEmployeeWireClaims;
exports.DefaultEmployeeClaims = DefaultEmployeeClaims;
exports.TestEmployeeClaims = TestEmployeeClaims;
const claims_1 = require("./claims");
const claims_2 = require("./claims");
const employee_right_1 = require("./employee-right");
var EmployeeClaimNames;
(function (EmployeeClaimNames) {
    EmployeeClaimNames["EMPLOYEE_RIGHTS"] = "employeeRights";
    EmployeeClaimNames["HUBS"] = "custom:hubs";
    EmployeeClaimNames["EXTERN_EMPLOYEE_ID"] = "custom:externalEmployeeId";
    EmployeeClaimNames["EMPLOYEE_FLEETS"] = "employeeFleets";
    EmployeeClaimNames["REGION"] = "employeeRegion";
})(EmployeeClaimNames || (exports.EmployeeClaimNames = EmployeeClaimNames = {}));
function requiredEmployeeArrayAttribute(claims, attribute, ec) {
    const value = (0, claims_1.requiredStringArrayAttribute)(claims, attribute, [], ec);
    return claims_1.WithDefault.from(employee_right_1.EmployeeRightEnDeCoder.toPermissions(value.val, ec), employee_right_1.EmployeeRightEnDeCoder.toPermissions());
}
function ToEmployeeWireClaims(claims) {
    const ret = {};
    if ((0, claims_1.isSome)(claims.employeeRights)) {
        ret[EmployeeClaimNames.EMPLOYEE_RIGHTS] =
            claims.employeeRights.val.toString();
    }
    if ((0, claims_1.isSome)(claims.hubs)) {
        ret[EmployeeClaimNames.HUBS] = (0, claims_2.toString)(claims.hubs);
    }
    if ((0, claims_1.isSome)(claims.externalEmployeeId)) {
        ret[EmployeeClaimNames.EXTERN_EMPLOYEE_ID] = (0, claims_2.toString)(claims.externalEmployeeId);
    }
    if ((0, claims_1.isSome)(claims.employeeFleets)) {
        ret[EmployeeClaimNames.EMPLOYEE_FLEETS] = (0, claims_2.toString)(claims.employeeFleets);
    }
    if ((0, claims_1.isSome)(claims.region)) {
        ret[EmployeeClaimNames.REGION] = (0, claims_2.toString)(claims.region);
    }
    return ret;
}
function toEntity(x) {
    return {
        employeeRights: claims_1.WithDefault.from(employee_right_1.EmployeeRightEnDeCoder.toPermissions(x.employeeRights), employee_right_1.EmployeeRightEnDeCoder.toPermissions()),
        hubs: claims_1.WithDefault.from(x.hubs, []),
        externalEmployeeId: claims_1.WithDefault.from(x.externalEmployeeId, ''),
        employeeFleets: claims_1.WithDefault.from(x.employeeFleets, []),
        region: claims_1.WithDefault.from(x.region, ''),
    };
}
function FromEmployeeWireClaims(claims, defaults = {}) {
    const withDefaults = {
        ...ToEmployeeWireClaims(toEntity(defaults)),
        ...claims,
    };
    const ec = new claims_1.ErrorCollector('employee');
    return new EmployeeClaimsImpl(ec, {
        employeeRights: requiredEmployeeArrayAttribute(withDefaults, EmployeeClaimNames.EMPLOYEE_RIGHTS, ec),
        hubs: (0, claims_1.requiredStringArrayAttribute)(withDefaults, EmployeeClaimNames.HUBS, [], ec),
        externalEmployeeId: (0, claims_1.requiredStringAttribute)(withDefaults, EmployeeClaimNames.EXTERN_EMPLOYEE_ID, '', ec),
        employeeFleets: (0, claims_1.requiredStringArrayAttribute)(withDefaults, EmployeeClaimNames.EMPLOYEE_FLEETS, [], ec),
        region: (0, claims_1.requiredStringAttribute)(withDefaults, EmployeeClaimNames.REGION, '', ec),
    });
}
class EmployeeClaimsImpl {
    constructor(ec, params) {
        _EmployeeClaimsImpl_ec.set(this, void 0);
        this.employeeRights = () => {
            return this.defaulted.employeeRights.val;
        };
        this.hubs = () => {
            return this.defaulted.hubs.val;
        };
        this.employeeFleets = () => {
            return this.defaulted.employeeFleets.val;
        };
        this.externalEmployeeId = () => {
            return this.defaulted.externalEmployeeId.val;
        };
        this.region = () => {
            return this.defaulted.region.val;
        };
        this.defaulted = params;
        __classPrivateFieldSet(this, _EmployeeClaimsImpl_ec, ec, "f");
    }
    wireEmployeeRights() {
        return (0, claims_1.isSome)(this.defaulted.employeeRights)
            ? this.employeeRights()
            : undefined;
    }
    wireHubs() {
        return (0, claims_1.isSome)(this.defaulted.hubs) ? this.hubs() : undefined;
    }
    wireExternalEmployeeId() {
        return (0, claims_1.isSome)(this.defaulted.externalEmployeeId)
            ? this.externalEmployeeId()
            : undefined;
    }
    wireRegion() {
        return (0, claims_1.isSome)(this.defaulted.region) ? this.region() : undefined;
    }
    errors() {
        return __classPrivateFieldGet(this, _EmployeeClaimsImpl_ec, "f").errors;
    }
    isError() {
        return __classPrivateFieldGet(this, _EmployeeClaimsImpl_ec, "f").isError();
    }
    lastError() {
        return __classPrivateFieldGet(this, _EmployeeClaimsImpl_ec, "f").lastError();
    }
    toJSON() {
        return ToEmployeeWireClaims(this.defaulted);
    }
    toParams() {
        const ret = {};
        if ((0, claims_1.isSome)(this.defaulted.employeeRights)) {
            ret.employeeRights = this.defaulted.employeeRights.val.toEnums();
        }
        if ((0, claims_1.isSome)(this.defaulted.hubs)) {
            ret.hubs = (0, claims_1.sanitizeStringArray)(this.defaulted.hubs.val);
        }
        if ((0, claims_1.isSome)(this.defaulted.externalEmployeeId)) {
            ret.externalEmployeeId = this.defaulted.externalEmployeeId.val;
        }
        return ret;
    }
}
_EmployeeClaimsImpl_ec = new WeakMap();
/**
 * @deprecated use TestCognitoClaims instead
 */
function DefaultEmployeeClaims() {
    return TestEmployeeClaims();
}
function TestEmployeeClaims() {
    return {
        employeeRights: [
            employee_right_1.EmployeeRight.BACKOFFICE_USER_USER_R,
            employee_right_1.EmployeeRight.OPEN_DRIVE_SHIFT,
        ],
        hubs: ['hub2', 'hub1'],
        externalEmployeeId: 'externalEmployeeId',
    };
}
class EmployeeBuilder {
    constructor(claims) {
        _EmployeeBuilder_claims.set(this, void 0);
        __classPrivateFieldSet(this, _EmployeeBuilder_claims, claims, "f");
    }
    build() {
        return FromEmployeeWireClaims({}, __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f"));
    }
    employeeRights(employeeRights) {
        __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f").employeeRights = employeeRights;
        return this;
    }
    hubs(hubs) {
        __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f").hubs = hubs;
        return this;
    }
    externalEmployeeId(externalEmployeeId) {
        __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f").externalEmployeeId = externalEmployeeId;
        return this;
    }
    employeeFleets(employeeFleets) {
        __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f").employeeFleets = employeeFleets;
        return this;
    }
    region(region) {
        __classPrivateFieldGet(this, _EmployeeBuilder_claims, "f").region = region;
        return this;
    }
}
exports.EmployeeBuilder = EmployeeBuilder;
_EmployeeBuilder_claims = new WeakMap();
//# sourceMappingURL=employee-claims.js.map